import _ from 'lodash';

import ExtendableError from '../lib/ExtendableError';
import { PaymentAuthCodes } from '../constants/AppConstants';

export class AmazonPayError extends ExtendableError {
    constructor(error) {
        super();

        const { body: { code, reason } } = error;
        let errorCode = code;

        if (code === 'PaymentRejected' && reason === PaymentAuthCodes.AMAZON_PAY_INVALID_PAYMENT_METHOD_ERROR) {
            errorCode = PaymentAuthCodes.AMAZON_PAY_INVALID_PAYMENT_METHOD_ERROR;
        }

        const messages = _.invert(PaymentAuthCodes);
        this.code = errorCode;
        this.message = messages[code] || messages[PaymentAuthCodes.UNKNOWN_ERROR];

    }

    name = 'AmazonPayError';
}



// WEBPACK FOOTER //
// ./src/errors/AmazonPayError.js